import {errorHandler, getSkey, request} from './HttpClient';
import {addEventListenerIfExist, addLiveEventListener} from './utils';

export default class Cart {
	constructor(app) {
		this.app = app;
		const self = this;

		addLiveEventListener('click', '.js-ordernow', function (e) {
			e.preventDefault();
			if (!('key' in this.dataset))
				throw new Error(`${this.cloneNode(false).outerHTML} has no 'data-key' attribute`);
			self.addToCart(this.dataset.key);
			self.countGA.call(self, this);
		});

		addLiveEventListener('click', '.js-delete', function (e) {
			e.preventDefault();
			const popup = document.querySelector('.js-cart-item-delete-confirmation');
			popup.classList.add('is-active');
			popup.querySelector('.js-delete-yes').onclick = e => {
				popup.classList.add('is-active');
				self.changeQuantity(this, 0);
			};
		});

		addLiveEventListener('change', '.js-quantity-input', function (e) {
			self.changeQuantity(this, this.value);
		});

		self.addPopup = document.querySelector('.js-cart-add-popup');
		self.popupOverlay = document.querySelector('.js-popup-overlay');

		self.discountCode();

		self.readCartStatus(); // read initial Cart
	}

	countGA(element) {
		try {
			ga('ec:addProduct', {
				'id': element.dataset.key,
				'quantity': 1
			});
			ga('ec:setAction', 'add');
			ga('send', 'event', 'Add to cart', element.dataset.producttype, element.dataset.title);
		} catch (e) {
			// analytics was blocked or not enabled
		}
	}

	addToCart(variantKey) {
		const self = this;

		const amountInput = document.querySelector('.js-amount-cart');
		const quantity = amountInput !== null ? parseInt(amountInput.value) : 1;

		if (location.pathname.startsWith('/cart')) { // CART VIEW SITE
			location.href = `/cart/add/${variantKey}/${quantity}`;
		} else { // OTHER SITES
			const popupBody = self.addPopup.querySelector('.js-popup-body');
			popupBody.innerHTML = '';
			self.popupOverlay.classList.add('is-active');
			self.addPopup.classList.add('is-active');
			request('/cart/add/', {
				method: 'POST',
				params: {
					redirectToView: false,
					itemKey: variantKey,
					quantity: quantity,
				}
			}).then(async result => {
				self.updateCartBadge(parseInt(result.headers.get('x-cart-total-quantity')));
				popupBody.innerHTML = await result.text();
				self.app.iconLoader.loadSvgs()
			}).catch(errorHandler);
		}
	}

	/**
	 * user changed quantity of an item
	 */
	changeQuantity(element, quantity) {
		const self = this;
		self.showbusy(element);
		const key = element.dataset.key;
		location.href = `/cart/add/${key}/${quantity}?relative=False`;
	}

	readCartStatus() {
		const self = this;
		request('/cart/async_status/')
			.then(response => response.json())
			.then(data => {
				self.updateCartBadge(data['cart_total_quantity'])
			})
			.catch(errorHandler);
	}

	/**
	 * Update the cart badge in the header with the given total quanity.
	 * @param {int} totalQuantity The total quantity of articles in the cart
	 */
	updateCartBadge(totalQuantity) {
		const badge = document.querySelector('.js-cart');
		if (badge && totalQuantity > 0) {
			const translation = badge.dataset.translationArticle;
			badge.title = `${totalQuantity} ${translation}`;
			badge.setAttribute('data-count', totalQuantity.toString());
		}
	}

	showbusy(input) {
		const parentItem = input.closest('.cart-item');
		parentItem.classList.add('is-busy');
		if (!parentItem.querySelector('.spinner-overlay')) {
			parentItem.insertAdjacentHTML('beforeend', `
				<div class="spinner-overlay">
					<div class="spinner">
						<div class="spinner-square"></div>
						<div class="spinner-square"></div>
						<div class="spinner-square"></div>
						<div class="spinner-square"></div>
						<div class="spinner-square"></div>
					</div>
				</div>
			`);
		}
	}

	/**
	 * Handle the discount code input.
	 */
	discountCode() {
		const input = document.querySelector('.js-cart-discountCode-input');
		const submitBtn = document.querySelector('.js-cart-discountCode-submit');

		addEventListenerIfExist('submit', e => {
			e.preventDefault();

			submitBtn.disabled = true;
			document.querySelector('.js-cart-discountCode-msg').classList.remove('is-active');

			getSkey()
				.then(skey => {
					request('/discountcode/applyCode', {
						params: {
							'code': input.value,
							'skey': skey,
						},
						method: 'POST',
					})
						.then(req => req.json())
						.then(data => {
							console.debug(data)
							if (data['success']) {
								// Don't reload here, we have to throw old errors like ?discountCodeIsInvalid=$reason away
								window.location = window.location.href.split('?')[0];
							} else {
								document.querySelector('.js-cart-discountCode-msg').classList.add('is-active');
								document.querySelector('.js-js-cart-discountCode-msg-content')
									.textContent = data['message'];
								submitBtn.disabled = false;
							}
						})
						.catch(error => {
							submitBtn.disabled = false;
							errorHandler(error);
						});
				});
		}, document.querySelector('.js-cart-discountCode-form'));
	}
}
